/** @typedef {String} PathifiedSvgContent */
/** @typedef {String} FeatherIconsPathDefinition */
/** @typedef {{ prefix: 'fe', iconName: 'feZapOff', icon: [Number|String, Number|String, import('feather-icons').FeatherAttributes, PathifiedSvgContent, FeatherIconsPathDefinition] }} FeatherZapOffIconData */

/** @type {FeatherZapOffIconData} */
const feZapOff = {
  prefix: 'fe',
  iconName: 'zap-off',
  icon: [
    24,
    24,
    '<polyline points="12.41 6.75 13 2 10.57 4.92"></polyline><polyline points="18.57 12.91 21 10 15.66 10"></polyline><polyline points="8 8 3 14 12 14 11 22 16 16"></polyline><line x1="1" y1="1" x2="23" y2="23"></line>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-zap-off"><path d="M12.41 6.75 L13 2 L10.57 4.92"/><path d="M18.57 12.91 L21 10 L15.66 10"/><path d="M8 8 L3 14 L12 14 L11 22 L16 16"/><path d="M1 1 L23 23"/></svg>',
    'M12.41 6.75 L13 2 L10.57 4.92 M18.57 12.91 L21 10 L15.66 10 M8 8 L3 14 L12 14 L11 22 L16 16 M1 1 L23 23',
    '"xmlns"="http=//www.w3.org/2000/svg" "width"="24" "height"="24" "fill"="none" "stroke"="currentColor" "stroke-width"=2 "stroke-linecap"="round" "stroke-linejoin"="round"',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      width: 24,
      height: 24,
      fill: 'none',
      stroke: 'currentColor',
      'stroke-width': 2,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    },
  ],
}

export default feZapOff
